<template>
  <div>
      <mu-drawer right :open="open">
        <div class="tips-content" v-for="(item,index) in tipsList" @click="continueTrain(item.uuid)">
            <div class="tips-text">您有一个正在进行中的训练</div>
            <div class="tips-name">患者：{{item.name}} </div>
            <div class="tips-surplus">剩余时间：{{item.left | timer}}</div>
            <em class="tips-right">></em>
        </div>
      </mu-drawer>
  </div>
</template>

<script>
import Vue from 'vue'
  export default {
    props: ['parentdata'],
    data () {
      return {
        open: false,   //默认是否显示训练中的患者列表
        tipsList:[],  //正在训练的患者列表
        timer:null,   //计时器对象
        choseInfo:null,//选中患者的信息
        doingTrain:[],   //正在训练的项目
        tmID: ''
      }
    },
    filters:{
      //自定义过滤器，过滤毫秒为日期格式
      timer:function(value) {
        let data = value/60;
        let h = Math.floor(data/60)
        let m = Math.floor(data);
        let s = Math.round((data-m)*60);
        if(h < 10){
          h = '0'+ h;
        }
        if(m < 10){
          m = '0'+ m;
        }
        if(s < 10){
          s = '0'+ s;
        }
        return h+":"+m+":"+s;
      }
      //end过滤器
    },
    mounted () {
      var self = this;
      self.fetch();
    },
    beforeDestroy () {
      var self = this;
      clearInterval(self.timer);//销毁页面的同时清除计时器
    },
    methods: {
      fetch(){//初始化查询当前医生名下正在训练的用户
        var self = this;
        self.checkTrainStatus();//初次查询
        clearInterval(self.timer);//首次加载先清除定时器
        // self.loopDoCheck();     //轮询查询（每分钟一次）
      },
      tipVanish () {
        var self = this;
        setTimeout(function(){
          self.open = false;
          clearInterval(self.timer);//清除计时器
        },7000);
      },
      continueTrain(caseid){
        var self = this;
        self.$http.get('/api/Train/infoTM',{
          params:{
            patient_uuid:caseid
          }
        }).then(function(res){
          this.tmID = res.data.data.id;
          var trueData = res.data;
          self.choseInfo = trueData.data;
          self.doingTrain = self.choseInfo.checked;
          self.timeLeft = self.choseInfo.time_left;
        }).then(function(){
          self.$router.push({path: '/trainTime/',query:{selectTrain:self.doingTrain,caseId:caseid,time:self.timeLeft}})
        });
      },
      checkTrainStatus(){//查询正在训练的患者列表
        var self = this;
        self.$http.get('/api/Train/usersTM')
        .then(function(res){
          let trueData = res.data;//真实数据
          if(trueData.total != 0){//判断是否有正在训练的患者
            self.open = true;
          }else{
            self.open = false;
            clearInterval(self.timer);//清除计时器
          }
          self.tipsList = trueData.data;
        })
        .then(function(){
          self.tipVanish();//5秒后tips提示框消失
        });
      },
      loopDoCheck(){
        var self = this;
        clearInterval(self.timer);
        self.timer = setInterval(() => {  //倒计时，每分钟执行一次
          self.checkTrainStatus();
        }, 60000);
      }
    }
  }
</script>

<style lang="css" scoped>
  .mu-drawer.open{
    min-height: 102px;
    position:fixed;
    top:100px;
    right:20px;
    border-radius:3px;
    overflow:hidden;
    background-color:rgba(0,0,0,0);
    box-shadow:none;
  }
  .mu-drawer.right{
    min-height: 102px;
    position:fixed;
    top:100px;
    overflow:hidden;
    background-color:rgba(0,0,0,0);
    box-shadow:none;
  }
  .tips-content{
    position:relative;
    top:0px;
    font-size: 14px;
    height:102px;
    line-height:102px;
    border-radius:3px;
    border:1px solid #eee;
    margin-bottom:10px;
    cursor:pointer;
    background-color:rgba(255,255,255,0.9);
  }
  .tips-right{
    font-style:normal;
    position:absolute;
    height:102px;
    line-height:102px;
    top:0px;
    right:10px;
    font-size:20px;
    color:#0A81E5;
  }
  .tips-text,.tips-name,.tips-surplus{
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    margin-left:20px;
  }
  .tips-text{
    color: #0A81E5;
    font-weight:bold;
    padding-top:20px;
  }
  .tips-name{
    margin-top:10px;
  }
  .tips-surplus{
    margin-top:5px;
  }
</style>



// WEBPACK FOOTER //
// trainTips.vue?594634f4